import React, { Component } from "react";
import CircularProgress from "components/CircularProgress";
import { connect } from "react-redux";
import { logoutUserResponse, setInitUrl, resetApp } from "actions";
import axios from "services/guest";

class index extends Component {
  componentDidMount() {
    const { logoutUserResponse, setInitUrl, resetApp, history } = this.props;
    const user = localStorage.getItem("user-data");
    delete axios.defaults.headers.common.Authorization;
    if (user) {
      setTimeout(() => {
        logoutUserResponse();
        resetApp();
        const url = '/';
        
        history.push(url);
      }, 1000);
    }
  }

  render() {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center h-100 w-100">
        <h1>Logging you out</h1>
        <CircularProgress />
      </div>
    );
  }
}

const mapStateToProps = ({ login }) => ({
  user: login.user,
});

export default connect(
  mapStateToProps,
  { logoutUserResponse, setInitUrl, resetApp }
)(index);



// WEBPACK FOOTER //
// ./containers/Logout.js